import React from "react";

const Blog = () => {
  return (
    <div className="mt-[15%] flex justify-center items-center">
      <p className="text-5xl font-semibold">Coming Soon</p>
    </div>
  );
};

export default Blog;
